<template>
    <div class="typewriter-container" v-if="typeChatbot === 'fake'">
      <span v-for="(char, index) in displayedText" :key="index" class="typewriter-span">{{ char }}</span>
    </div>
    <div class="typewriter-container" @click.prevent="onClick" v-else v-html="displayedText"></div>
  </template>
  
  <script>
  export default {
    props: {
      text: {
        type: String,
        required: true
      },
      typingSpeed: {
        type: Number,
        default: 10
      },
      typeChatbot: {
        type: String,
        default: 'fake'
      }
    },
    data() {
      return {
        displayedText: '',
        currentCharIndex: 0
      };
    },
    watch: {
      typeChatbot: {
        handler() {
          this.displayedText = ''
          this.currentCharIndex = 0
        },
        immediate: true
      },
      text: {
        handler() {
          if (this.typeChatbot === 'fake') {
            this.startTyping();
          } else {
            this.typeText()
          }
        },
        immediate: true
      }
    },
    methods: {
      startTyping() {
        this.displayedText = '';
        this.currentCharIndex = 0;
        const typeNextChar = () => {
          this.$emit('goToBottom')
          if (this.currentCharIndex < this.text.length) {
            this.displayedText += this.text.charAt(this.currentCharIndex);
            this.currentCharIndex++;
            setTimeout(typeNextChar, this.typingSpeed);
          }
        };
        typeNextChar();
      },
      typeText() {
        if (this.currentCharIndex < this.text.length) {
          this.$emit('goToBottom')
          this.displayedText += this.text[this.currentCharIndex];
          this.currentCharIndex++;
          setTimeout(this.typeText, this.typingSpeed);
        }
      },
      onClick(ev) {
        if (ev.target.tagName === "A") {
          this.$router.push(new URL(ev.target.href).pathname);
        }
      }
    }
  };
  </script>
  
  <style>
  .typewriter-container {
    animation: blink-caret 0.1s step-end infinite;
  }
  .typewriter-span {
    text-transform: none !important;
  }
  @keyframes blink-caret {
    from, to {
      background-color: transparent;
    }
    50% {
      background-color: transparent;
    }
  }
  </style>